@import '../ui-cms-contact-channels-footer';

ui-cms-contact-channels-footer-phone {
  display: block;
}
